// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__22U0A","signatureBlock":"Footer_signatureBlock__2D_rV","signature":"Footer_signature__2PXxP"};